<template>
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.4911 5.04444L9.48264 9.05296C9.92808 10.721 9.49648 12.5746 8.18783 13.8833L1.11682 6.81221C2.42541 5.50356 4.279 5.07197 5.94709 5.51744L9.95561 1.50892"
      fill="white"
    />
    <line x1="7.32925" y1="8.37629" x2="0.929252" y2="13.9763" stroke="white" />
    <path d="M9.40002 0.800003L14.2 5.60001" stroke="white" />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  name: "PinnIcon",
})
</script>

<style lang="scss" scoped></style>
